const DEFAULT_COLLISION_PADDING = 16;

export { DEFAULT_COLLISION_PADDING };
//# sourceMappingURL=constants.mjs.map
